import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Store } from '@ngxs/store';
import { ScreeningState } from '@app/store/screening/screening.state';

@Component({
  selector: 'app-modal-checklist',
  templateUrl: './modal-checklist.component.html',
  styleUrls: ['./_modal-checklist.component.sass'],
})
export class ModalCheckListComponent implements OnInit {
  displayedColumns: string[];
  idTrade: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private _store: Store) {}

  ngOnInit(): void {
    this._buildColumns();
    this._getIdTrade();
  }

  private _buildColumns() {
    const [questions] = this.data.list;
    this.displayedColumns = Object.keys(questions);
  }

  private _getIdTrade() {
    const { idTrade } = this._store.selectSnapshot(ScreeningState);
    this.idTrade = idTrade;
  }
}
